import React from 'react';

import './video-behind-text.css';

// define the props type here
type VideoBehindTextProps = {
   children: React.ReactNode,
   mainText?: string,
   subText?: string,
   video?: boolean,
   url: string
}





//const a:React.VideoHTMLAttributes<HTMLVideoElement> = {typeof:"video/mp4"};

// use the React.FunctionalComponent to type the props
const VideoBehindText: React.FC<VideoBehindTextProps> = ({ mainText, subText, video, url, children }) => (
   <div className="main">
      <div className="top">
         <div className="video-container">
            <div className="tint-overlay">
               <div className="text-overlay">
                  {mainText ? <h1>{mainText}</h1> : ''}
                  {subText ? <p>{subText}</p> : ''}
               </div>
            </div>
            {
               video
                  ? <video className="background" autoPlay loop muted playsInline src={url} typeof="video/mp4" width="640" height="360" />
                  : <img className="background" alt="Ethan at piano on stage." src={url} width="640" height="360" />
            }
         </div>
      </div>
      <div className="bottom">
         {children}
      </div>
   </div>
)

export default VideoBehindText;